import * as yup from 'yup';

const schema = yup.object({
  email: yup.string().email('Invalid email format').required('Email is required'),

  studies: yup
    .object()
    .test('at-least-one-study', 'At least one study must be selected', value => value && Object.values(value).some(Boolean))
    .required('Studies are required'),

  waves: yup
    .object()
    .test('at-least-one-wave', 'At least one wave must be selected', value => value && Object.values(value).some(Boolean))
    .required('Waves are required'),
});

export default schema;
